import { ICartItemErrorType, type Product } from "@jti/magento";

export const hasOngoingSubscriptionError = (items: Product[] = []): boolean =>
  items.some((item) => item.errors?.some((error) => error?.code === ICartItemErrorType.OngoingSubscription));
